import { render, staticRenderFns } from "./ShiftLogsAvg.vue?vue&type=template&id=00dccc8d&scoped=true"
import script from "./ShiftLogsAvg.vue?vue&type=script&lang=js"
export * from "./ShiftLogsAvg.vue?vue&type=script&lang=js"
import style0 from "./ShiftLogsAvg.vue?vue&type=style&index=0&id=00dccc8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dccc8d",
  null
  
)

export default component.exports